import React from 'react'

interface CalendarProps {
  width?: number,
  height?: number
}

const Calendar = ({ height = 50, width = 54}: CalendarProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--calendar"
      width={width}
      height={height}>
      <defs>
        <filter x="-38.7%" y="-38.2%" width="177.4%" height="176.4%" filterUnits="objectBoundingBox" id="a">
          <feGaussianBlur stdDeviation="3.984" in="SourceGraphic"></feGaussianBlur>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M26.154 3.991h2.36c1.312 0 2.374 1.085 2.374 2.425v5.091H0V6.417C0 5.076 1.067 3.99 2.38 3.99h2.356V1.683c0-.68.543-1.236 1.209-1.236.665 0 1.21.556 1.21 1.236v2.308h16.581V1.683c0-.68.544-1.236 1.21-1.236.664 0 1.209.556 1.209 1.236v2.308zm4.734 11.368v13.938c0 1.34-1.061 2.424-2.373 2.424H2.38C1.067 31.721 0 30.637 0 29.297V11.508h30.865l.023 3.851z" fill="#B4C3D8" filter="url(#a)" transform="translate(11 9)"></path>
        <path d="M41.888 23.59v13.938c0 1.34-1.061 2.424-2.373 2.424H13.38c-1.312 0-2.379-1.084-2.379-2.424V19.74h30.865l.023 3.851z" fill="#FFF"></path>
        <path d="M28.325 31.66l.013-7.318a1 1 0 0 0-1.002-1.001l-1.08.001a1 1 0 0 0-.999.999l-.013 7.317a1 1 0 0 0 1.002 1.002l1.081-.002a1 1 0 0 0 .998-.998zM28.331 35.664l.001-.66a1 1 0 0 0-1.002-1.002l-1.08.002a1 1 0 0 0-.999.998v.66a1 1 0 0 0 1 1.003l1.082-.002a1 1 0 0 0 .998-.999z" fill="#394F5A"></path>
        <path d="M41.888 17.806v2.29H11v-5.092c0-1.34 1.067-2.424 2.379-2.424H39.514c1.312 0 2.374 1.084 2.374 2.424v2.802z" fill="#B5D2E1"></path>
        <path d="M17.042 16.326c-.665 0-1.209-.557-1.209-1.237v-4.853c0-.68.544-1.236 1.21-1.236.664 0 1.209.556 1.209 1.236v4.853c0 .68-.545 1.237-1.21 1.237M35.935 16.326c-.665 0-1.21-.557-1.21-1.237v-4.853c0-.68.545-1.236 1.21-1.236.665 0 1.21.556 1.21 1.236v4.853c0 .68-.545 1.237-1.21 1.237" fill="#FFF"></path>
        <path d="M27 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM3 24a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM53 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" stroke="#B5D2E1" strokeWidth="1.68" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M2 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M43 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M49 31.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" fill="#B5D2E1"></path>
      </g>
    </svg>
  )
}

export default Calendar